export default __webpack_public_path__ + "static/media/new_fk_logo.6bb7ba3f.png";